<template>
	<div class="list-panel column main is-7">
		<div class="panel list-panel">
			<div class="panel-block title">
				Frågor
			</div>
			<div class="panel-block">
				<div class="columns header">
					<div class="box">
						Antal frågor: {{ questionGroup.questions.length }}
					</div>
					<button class="button is-small is-info" @click.stop="onAdd">
						<span class="icon"><i class="fas fa-plus"/></span
						><span>Ny fråga</span>
					</button>
				</div>
			</div>
			<div v-if="questions.length > 0" class="panel-block block">
				<div />
				<div class="panel-list-header">
					<div class="panel-header-item">Namn</div>
					<div class="panel-filler" />
				</div>
				<div
					class="panel-list"
					v-for="question in questions"
					:key="question.id"
					@click.stop="onEdit(question)"
				>
					<div class="panel-list-item">
						{{ question.name || question.description }}
					</div>
					<div class="list-button" @click.stop="onEdit(question)">
						<i class="fas fa-edit"></i>
					</div>
          <!-- Disabled delete until its verified in api
        <div class="list-button" @click.stop="onDelete(question)">
          <i class="fas fa-trash-alt"></i>
        </div>
        --></div>
			</div>
			<div class="panel-block block" v-if="questions.length == 0">
				<div class="panel-list no-hover">
					<p class="panel-list-item">Inga frågor</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		questions: Array,
		questionGroup: Object
	},
	methods: {
		onDelete(question) {
			this.$emit('delete', question);
		},
		onEdit(question) {
			this.$emit('edit', question);
		},
		onAdd() {
			this.$emit('add', this.questionGroup);
		}
	}
};
</script>
